// @flow
import React, { Component } from 'react'
import { Buttons, FormControls } from '@lanetix/unum'
import { Link } from 'react-router-dom'
import routerFunction from 'client/route.js'
import axios from 'axios'
// $FlowFixMe
export class PasswordResetForm extends Component {
  // state: {
  //   email: string
  // }

  static displayName: any = 'PasswordResetForm'

  state: any = {
    email: ''
  }
  // $FlowFixMe
  onSubmit: ((event: any) => Promise<void>) = async (event: SyntheticEvent) => {
    const { email } = this.state
    const router = routerFunction()
    event.preventDefault()
    try {
      await axios.post('/api/v1/forgot-password/email', { email })
      router.navigate('/forgot-password/email-sent')
    } catch (e) {
      router.navigate('/forgot-password/email-send-error')
    }
  }
  // $FlowFixMe
  onInput: ((key: string, any) => void) = (key: string, { target: { value } }: SyntheticInputEvent) => {
    this.setState({ [key]: value })
  }

  render (): any {
    return (
      <form className='pw-reset-email__form' onSubmit={this.onSubmit}>
        <FormControls.Text placeholder='Email' onInput={this.onInput.bind(this, 'email')} />
        <Buttons.PillButton className='pw-reset-email__button' type='submit' success block>Submit</Buttons.PillButton>
        <Link to='/' className='pw-reset-password__login'>Return to Login Page</Link>
      </form>
    )
  }
}

export default PasswordResetForm
